import { withDependencies, named } from '@wix/thunderbolt-ioc'
import { REPEATER_DELIMITER } from '@wix/thunderbolt-commons'
import { BrowserWindow, BrowserWindowSymbol, EditorFeatureConfigSymbol } from '@wix/thunderbolt-symbols'
import type { IViewerManagerImplementor } from 'thunderbolt-viewer-manager-types'
import type { ViewerManagerDisplayedOnlyComponentsApiEditorConfig } from './types'
import { name } from './symbols'

export const ViewerManagerDisplayedOnlyComponentsApi = withDependencies(
	[named(EditorFeatureConfigSymbol, name), BrowserWindowSymbol],
	(
		{ repeaterIdToFirstItemId }: ViewerManagerDisplayedOnlyComponentsApiEditorConfig,
		window: NonNullable<BrowserWindow>
	): IViewerManagerImplementor<'displayedOnlyComponents'> => {
		const state: Record<string, string> = { ...repeaterIdToFirstItemId }
		return {
			displayedOnlyComponents: {
				// TODO: Delete when Bolt is not needed any more: TB-3928
				setRepeaterToTemplateItem: (compId: string, templateItem: string) => (state[compId] = templateItem),
				// @ts-expect-error
				getRepeaterToTemplateItem: (compId: string) => {
					const fromState = state[compId]
					const fromConfig = repeaterIdToFirstItemId[compId]
					return fromState || fromConfig
				},
				// @ts-ignore
				getRepeatedComponents: (compId) =>
					Array.from(window.document.querySelectorAll(`[id^="${compId}${REPEATER_DELIMITER}"]`)).map(
						(node) => node.id
					),
			},
		}
	}
)
